import React from 'react';
import { string, func } from 'prop-types';
import { Translate } from 'react-localize-redux';
import { AVAILABLE_LANGUAGES } from '../../../constants';

import styles from '../preview.module.css';

const PreviewLanguageSelector = ({ previewLang, onLanguageSelect }) => {
  const isCurrentLang = (lang) => previewLang === lang;

  return (
    <div className={styles.previewLanguageContainer}>
      {AVAILABLE_LANGUAGES.map((lang) =>
        (
          <button
            type="button"
            onClick={() => onLanguageSelect(lang)}
            key={lang}
            className={`${styles.languageText}
                          ${isCurrentLang(lang) && styles.activeLanguageText}
                          button--action theme-transparent`}
          ><Translate id={`inLanguage.${lang}`} />
          </button>
        ))}
    </div>
  );
};

PreviewLanguageSelector.propTypes = {
  previewLang: string.isRequired,
  onLanguageSelect: func.isRequired
};

export default PreviewLanguageSelector;
